<template>

    <div class="footer-social">
        <p class="footer-social__title">{{ t("follow_us") }}:</p>
        <ul class="menu">
            <li class="menu__item">
                <a href="https://www.facebook.com/Slask.bez.granic/" target="_blank" :title="t('follow_us')">
                    <ShowSvg icon="social-facebook" color="none"/>
                </a>
            </li>

        </ul>
    </div>

</template>

<script>
import ShowSvg from "@/Library/Show/Svg.vue";
import View from "@/views/View.vue"

export default {
    name: "FooterSocial",
    components: {
        ShowSvg
    },
    extends: View
}
</script>

<style scoped lang="scss">

.footer-social {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;

  @media screen and (max-width: 767px) {
    flex-direction: column;
    align-items: start;
  }

  &__title {
    min-width: fit-content;

    @media screen and (max-width: 767px) {
      min-width: unset;
    }
  }
}

.menu {
  list-style: none;
  display: flex;
  flex-direction: row;
  gap: 20px;
  width: 100%;

  &__item {
    margin: 7px 0;
    padding: 2px 0;
    cursor: pointer;
    transition: all 0.25s ease 0s;

    &:hover {
      color: rgb(73, 78, 155);
    }

    & .svg-icon {
      display: flex;
    }
  }
}

html.contrast {

  & .menu {

    &__item {

      &:hover {
        color: gold;
      }
    }
  }
}

</style>